import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { DownloadIcon, GraphArrow, PrintIcon } from '../../Assets/icons';
import AgeGroupDonut from '../../Components/General/AgeGroupDonught';
import Header from '../../Components/General/Header';
import LayoutComponent from '../../Components/General/LayoutComponent';
import LineGraph from '../../Components/General/LineGraph';
import PatientStatsDonut from '../../Components/General/PatientFlow';
import ShowDateRange from '../../Components/General/ShowDateRange';
import StatsCard from '../../Components/General/StatsCard';
import CustomDropdown from '../../Components/UI/CustomDropdown';
import Loader from '../../Components/UI/Loader';
import { timePeriodOptions } from '../../data';
import useStats from '../../Features/useStats';
import { convertIntoISO, numberFormatter } from '../../Helpers';
import classes from './Statistics.module.css';
import { useNavigate } from 'react-router-dom';
const checkCard = (cardName) => {
  return {
    [classes.totalPatient]: cardName === 'Total Patients',
    [classes.newPatients]: cardName === 'New Patients',
    [classes.cashFlow]: ['Cash Flow', 'Payments'].includes(cardName),
    [classes.followUp]: cardName === 'Follow-up'
  };
};

const statsType = ['totalPatients', 'uniquePatients', 'cashFlow', 'oldPatients'];
function formatString(input) {
  return input
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
    .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter
}
const Statistics = () => {
  const {
    getStatistics,
    statistics,
    getGraphView,
    graphView,
    getPatientFlow,
    getAgeGroupChart,

    patientFlow,
    ageGroup
  } = useStats();
  const navigate = useNavigate();
  const [selectedPeriod, setSelectedPeriod] = useState(timePeriodOptions[0]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);
  const onPrev = () => {
    return;
  };
  const onNext = () => {
    navigate('/dashboard');
  };
  useEffect(() => {
    (async () => {
      setLoading(true);
      await Promise.allSettled([
        getStatistics({
          timeRange: 'monthly',
          timeZone: 'Asia/Karachi'
        }),
        getGraphView({
          // startUtcDate: '2025-01-29T06:47:25.689Z',
          // endUtcDate: '2025-01-29T06:47:25.689Z',
          chartType: 1,
          startUtcDate: convertIntoISO(dateRange[0]?.startDate),
          endUtcDate: convertIntoISO(dateRange[0]?.endDate)
        }),
        getPatientFlow({
          startUtcDate: convertIntoISO(dateRange[0]?.startDate),
          endUtcDate: convertIntoISO(dateRange[0]?.endDate),
          chartType: 1,
          genderId: 0
        }),
        getAgeGroupChart({
          // startUtcDate: '2025-01-29T06:47:25.689Z',
          // endUtcDate: '2025-01-29T06:47:25.689Z',
          chartType: 1,
          startUtcDate: convertIntoISO(dateRange[0]?.startDate),
          endUtcDate: convertIntoISO(dateRange[0]?.endDate),
          ageGroupId: 0
        })
      ]);
      setLoading(false);
    })();
  }, [dateRange]);

  // const decideName = (cardName) => {
  //   let name = '';
  //   if (cardName === 'totalPatients') {
  //     name = 'Total Patients';
  //   }else if(cardName === "")
  // };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <Header title="Statistics" onPrev={onPrev} onNext={onNext} />
          <div className={classes.page}>
            <LayoutComponent>
              <div className={classes.wrapper}>
                <section className={classes.topActions}>
                  <div>
                    <ShowDateRange value={dateRange} setter={setDateRange} />
                  </div>
                  <div className={classes.quickActions}>
                    {/* <div className={classes.calendarIndicator}>
                  <span>This Month</span>
                  <span>
                    <DownFullArrow />
                  </span>
                </div> */}
                    <CustomDropdown
                      options={timePeriodOptions}
                      value={selectedPeriod}
                      setter={(e) => {
                        getStatistics({
                          timeRange: e?.value,
                          timeZone: 'string'
                        });
                        setSelectedPeriod(e);
                      }}
                    />
                    <DownloadIcon />
                    <PrintIcon />
                  </div>
                </section>

                <div className={classes.statisticsWrapper}>
                  <Row className={classes.statisticsGrid}>
                    {statsType?.map((stats, index) => {
                      const data = statistics?.statisticsResult?.[stats];

                      // console.log(
                      //   'statistics?.statisticsResult[stats];',
                      //   statistics?.statisticsResult[stats]
                      // );
                      return (
                        <Col
                          // xl={2}
                          md={3}
                          sm={4}
                          xs={6}
                          key={stats}
                          className={clsx({
                            [classes.pr0]: index % 2 === 0
                          })}>
                          <StatsCard
                            sessionActive={true}
                            cardName={formatString(stats)}
                            content={numberFormatter(data?.currentValue)}
                            bottom={
                              <>
                                <span
                                  className={clsx(
                                    classes.graphIndicator,
                                    checkCard(formatString(stats)),
                                    {
                                      [classes.down]: data?.percentageValue < 0
                                    }
                                  )}>
                                  <GraphArrow className={clsx(checkCard(formatString(stats)))} />
                                  <span className={classes.green}>
                                    {data?.percentageValue} This month
                                  </span>
                                </span>
                              </>
                            }
                          />
                        </Col>
                      );
                    })}
                  </Row>
                </div>

                <Row className={classes.statsGrid}>
                  <Col lg={6}>
                    {graphView && (
                      <LineGraph
                        dateRange={dateRange}
                        getGraphView={getGraphView}
                        initialData={graphView}
                      />
                    )}
                    <div>
                      <AgeGroupDonut
                        dateRange={dateRange}
                        patientFlow={ageGroup}
                        onFilter={getAgeGroupChart}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <PatientStatsDonut
                      dateRange={dateRange}
                      patientFlow={patientFlow}
                      onFilter={getPatientFlow}
                    />
                  </Col>
                  <Col lg={12}></Col>
                </Row>
              </div>
            </LayoutComponent>
          </div>
        </div>
      )}
    </>
  );
};

export default Statistics;
